import * as types from '../constants';

export const searchForTags = (queryString) => ({
  type: types.SEARCH_FOR_TAGS,
  queryString,
});

export const resetTagSearch = () => ({
  type: types.RESET_TAG_SEARCH,
});

export const addIOCTag = (tagName, ioc) => ({
  type: types.ADD_IOC_TAG,
  tagName,
  ioc,
});

export const removeIOCTag = (tag, ioc) => ({
  type: types.REMOVE_IOC_TAG,
  tag,
  ioc,
});

export const deleteTag = (id, selectedProfile) => ({
  type: types.DELETE_TAG,
  id,
  selectedProfile,
});
